module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n        ☰\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [_c('Dropdown', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    staticStyle: {
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "src": _vm.userImage,
      "alt": "o"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" \n      ")])]), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('Dropdown-item', [_c('p', {
    staticClass: "dropdown-itemp",
    on: {
      "click": _vm.changePwds
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-settings"
    }
  }), _vm._v("\n                        修改密码\n                    ")], 1)]), _vm._v(" "), _c('Dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.Logout
    }
  }, [_c('p', {
    staticClass: "dropdown-itemp"
  }, [_c('Icon', {
    attrs: {
      "type": "power"
    }
  }), _vm._v("\n                        退出登录\n                    ")], 1)])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7876965b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 108
// module chunks = 83